import { render, staticRenderFns } from "./ReferralsNewSearchForm.vue?vue&type=template&id=5813183a"
import script from "./ReferralsNewSearchForm.vue?vue&type=script&lang=js"
export * from "./ReferralsNewSearchForm.vue?vue&type=script&lang=js"
import style0 from "./ReferralsNewSearchForm.vue?vue&type=style&index=0&id=5813183a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports